/** Counts the words (any whitespace delimited text) in a string. */
/**
 * @deprecated Fresco's Formly implementation is deprecated, please use reactive forms or another option.
 */
export function countWords(text: string) {
  const count = text ? text.split(/\s+/).filter((w) => w).length : 0;
  return count;
}
